// TODO: maybe move into another location

import { createSelector } from "reselect";

import {
  ContentModule,
  makeGetSectionContentModules,
  makeGetSectionContents,
  makeGetSectionExerciseContentModules
} from "seneca-common/features/course/state";
import { getModuleType as contentModule_getModuleType } from "seneca-common/features/course/state/selectors/state/modules/module";
import { ModuleRegistry } from "seneca-common/features/module/registry";

import type { isWrongAnswerModeAvailableForSection } from "../../../../../wrong-answers/selectors/isWrongAnswerModeAvailableForSection";
// TODO: probably should move this to somewhere more common
import { filterForDevice } from "../../../session/logic/filterForDevice";
import makeGetIncorrectContentModules from "./makeGetIncorrectContentModules";
import makeNotAvailableDueToContentFormat from "./makeNotAvailableDueToContentFormat";
import makeNotAvailableDueToDevice from "./makeNotAvailableDueToDevice";
import { FilterContent } from "./types";

export type GetNumberOfAvailableWrongModules = (state: any) => number;
export type WrongModuleModeAvailable = (state: any) => boolean;

type Args = {
  moduleRegistry: ModuleRegistry;
  sectionId: string;
  filterContentModuleForDevice?: FilterContent;
};

/**
 * @deprecated consider using isWrongAnswerModeAvailableForSection instead
 * {@link isWrongAnswerModeAvailableForSection}
 */

export default function makeWrongAnswerModeSelectors({
  moduleRegistry,
  sectionId,
  filterContentModuleForDevice = defaultFilterContentModuleForDevice
}: Args) {
  const getSectionContentModules = makeGetSectionContentModules(sectionId);
  const getSectionExerciseContentModules =
    makeGetSectionExerciseContentModules(sectionId);
  const getSectionContents = makeGetSectionContents(sectionId);
  const getIncorrectContentModules = makeGetIncorrectContentModules(sectionId);

  const getNumberOfAvailableWrongModules: GetNumberOfAvailableWrongModules =
    createSelector(getIncorrectContentModules, incorrectContentModules => {
      return incorrectContentModules.filter(filterContentModuleForDevice).size;
    });

  const wrongModuleModeNotAvailableDueToDevice = makeNotAvailableDueToDevice(
    getIncorrectContentModules,
    filterContentModuleForDevice
  );
  const wrongModuleModeNotAvailableDueToContentFormat =
    makeNotAvailableDueToContentFormat(
      moduleRegistry,
      getSectionContents,
      getSectionContentModules,
      getSectionExerciseContentModules
    );

  const wrongModuleModeAvailable: WrongModuleModeAvailable = createSelector(
    wrongModuleModeNotAvailableDueToContentFormat,
    getNumberOfAvailableWrongModules,
    (notAvailableDueToContentFormat, numberOfAvailableWrongModules) => {
      return (
        !notAvailableDueToContentFormat &&
        numberOfAvailableWrongModules !== null &&
        numberOfAvailableWrongModules > 0
      );
    }
  );

  return {
    getNumberOfAvailableWrongModules,
    wrongModuleModeNotAvailableDueToDevice,
    wrongModuleModeNotAvailableDueToContentFormat,
    wrongModuleModeAvailable
  };
}

export function defaultFilterContentModuleForDevice(
  contentModule: ContentModule
) {
  return filterForDevice(contentModule_getModuleType(contentModule));
}
